import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const integrationsSlice = createAppSlice({
  name: 'integrations',
  initialState,
  reducers,
});

export const { fetchAvailableInstances, fetchRSVPLinkSync, toggleEventInstance, approveRSVPEventLink, fetchSolutions } =
  integrationsSlice.actions;

export default integrationsSlice.reducer;
